import { BaseController } from '@shared/basecontroller.controller';
import { RequestLinkBankForm } from './model/form.model';
import { LinkBankFormErrorModel } from './model/form-error.model';
import { toApiAcceptedDateFormat } from '../../payload.utils';

const PAGE_WITHDRAWAL = 'withdrawal';
const ACTION_CREATE = 'CREATE';
const ACTION_UPDATE = 'UPDATE';

export class LinkBank {
  constructor(FormService, PaymentOptionApiService, PageService, AppService, StorageService, $state, $timeout, $scope) {
    'ngInject';

    this.FormService = FormService;
    this.PaymentOptionApiService = PaymentOptionApiService;
    this.PageService = PageService;
    this.AppService = AppService;
    this.StorageService = StorageService;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;

    this.$scope.$on('reload.bank-details', () => {
      this.editBankAccountDetails(this.formData);
    });

    this.$scope.$on('reload.off-default', () => {
      this.offDefaultSaving();
    });
  }

  $onInit() {
    this.form = new RequestLinkBankForm();
    this.error = new LinkBankFormErrorModel();
    this.getMemberDetails();
  }
  
  getMemberDetails() {
    let memberDetails = JSON.parse(this.StorageService.getItem('member_details'));
    this.form.dateOfBirth = toApiAcceptedDateFormat(memberDetails.birth_date);
    this.form.citizenship = memberDetails.country;
  }

  editBankAccountDetails(resp) {
    this.form.action = ACTION_UPDATE;
    this.error.hasError = true;
    this.form.bankPaymentOption = resp.id;
    this.form.isDefault = resp.fields.is_default;
    this.form.beneficiaryAccount = resp.fields.account_id;
    this.form.beneficiaryAccountName = resp.fields.account_name;
    this.form.beneficiaryAddress = resp.fields.account_address;
    this.form.dateOfBirth = resp.fields.birth_date;
    this.form.citizenship = resp.fields.citizenship;
    this.form.beneficiaryCode = resp.fields.swift_code;
    this.form.bankAddress = resp.fields.bank_address;
    this.form.beneficiaryBank = resp.fields.bank_name;
    this.$timeout(() => {
      this.AppService.broadcast('reload.switchery');
      this.PageService.showModal('bankAccountModal');
    }, 200);
  }

  submit() {
    if (this.form.action === ACTION_CREATE) {
      this.createBank();
    } else if (this.form.action === ACTION_UPDATE) {
      this.updateBank();
    }
  }

  createBank() {
    this.FormService.isSubmitting.next(true);
    this.PaymentOptionApiService.linkBankAccountRequest(this.form.toPayload())
    .then((resp) => {
      this.error.hasError = false;
      this.FormService.isSubmitting.next(false);
      if (resp.fields.is_default) {
        this.AppService.broadcast('reload.member-payment-option');
      } else {
        this.appendBankAccountToList(resp);
      }
      this.$timeout(() => {
        $('#bankAccountModal').modal('hide');
        this.resetForm();
        this.error.hasError = true;
      }, 2000);
    })
    .catch((errors) => {
      this.error.hasError = true;
      this.FormService.isSubmitting.next(false);
      if (errors.errors) {
        this.error.formError = errors.errors[0];
        this.$timeout(() => {
          this.PageService.showModal('warningModal');
        }, 500);
      }
      this.error.setFormErrors(errors);
    });
  }

  updateBank() {
    this.FormService.isSubmitting.next(true);
    this.PaymentOptionApiService.updateBankAccountRequest(this.form.toUpdatePayload())
    .then((resp) => {
      this.error.hasError = false;
      this.FormService.isSubmitting.next(false);
      this.form.successMessage.body = 'Bank account successfully updated.';
      this.$timeout(() => {
        $('#bankAccountModal').modal('hide');
        this.resetForm();
        this.AppService.broadcast('reload.member-payment-option');
        this.error.hasError = true;
      }, 1000);
    })
    .catch((errors) => {
      this.error.hasError = true;
      this.FormService.isSubmitting.next(false);
      if (errors.errors) {
        this.error.formError = errors.errors[0];
        this.$timeout(() => {
          this.PageService.showModal('warningModal');
        }, 500);
      }
      this.error.setFormErrors(errors);
    });
  }

  getPageName() {
    let path = window.location.pathname;
    return path.substring(path.lastIndexOf('/') + 1);
  }

  isWithdrawal() {
    return this.getPageName() === PAGE_WITHDRAWAL;
  }

  offDefaultSaving() {
    this.form.isDefault = false;
    this.form.saveBankAccount = false;
  }

  appendBankAccountToList(resp) {
    sessionStorage.setItem('temp_bank', JSON.stringify(resp));
    this.AppService.broadcast('reload.bank-sidebar');
  }

  goToSettings() {
    $('#warningModal').modal('hide');
    $('#bankAccountModal').modal('hide');
    $('.modal-backdrop').hide();
    this.$state.go('settings');
  }

  onCloseForm() {
    $('#bankAccountModal').modal('hide');
    this.resetForm();
  }

  resetForm() {
    this.form.reset();
    this.error.clearFormErrors();
    this.FormService.isSubmitting.next(false);
    $('#default').prop('checked', true);
    $('#save').prop('checked', true);
    this.getMemberDetails();
  }
}

export default LinkBank;


// WEBPACK FOOTER //
// ./client/app/shared/system-components/link-bank-widget/link-bank-widget.controller.js